import fp from 'lodash/fp';
import * as actions from './actions';
import { getTimeStamp } from '../webcommon/common/helpers';

export const INITIAL_STATE = {
    userName: '',
    email: '',
    initialisedUserProfile: false,
    loadingUserProfile: false,
    lastUpdatedUserProfile: getTimeStamp(),
    columnsForUserProfile: [],
    rowsForUserProfile: [],
    userRole: [],
    appConfig: null,
    appConfigSaving: false,
    appConfigSaveError: null,
    appConfigSaved: false
};

const setUserProfileInitialised = fp.set('initialisedUserProfile');
const setUserProfileLoading = fp.set('loadingUserProfile');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_USER_PROFILE_INITIALISED:
            return setUserProfileInitialised(action.initialised, state);
        case actions.SET_USER_PROFILE_LOADING:
            return setUserProfileLoading(action.loading, state);
        case actions.SET_USER_ROLE:
            return { ...state, userRole: action.role };
        case actions.SET_USER_INFO:
            return {
                ...state,
                rowsForUserProfile: action.info,
                lastUpdatedUserProfile: getTimeStamp(),
                loadingUserProfile: false
            };
        case actions.SET_APP_CONFIG:
            return { ...state, appConfig: action.data };
        case actions.SET_APP_CONFIG_SAVING:
            return { ...state, appConfigSaving: action.saving };
        case actions.SET_APP_CONFIG_SAVE_ERROR:
            return { ...state, appConfigSaveError: action.error };
        case actions.SET_APP_CONFIG_SAVED:
            return { ...state, appConfigSaved: action.saved };
        default:
            return state;
    }
}
